"use strict";
document.addEventListener("DOMContentLoaded", () => {
    document.documentElement.classList.add("js-ready");
}, { once: true });
